import { useState, useCallback } from "react";
import * as api from "../api";

export function useTeams(token, showToast) {
  const [teams, setTeams] = useState([]);
  // Los permisos por equipo (p. ej. quien es de TIC) se deducen de esta lista,
  // asi que hay que poder distinguir "aun no ha llegado" de "no pertenece a
  // ninguno": sin esto se echaria de Incidencias a un TIC recien entrado.
  const [teamsCargados, setTeamsCargados] = useState(false);

  const loadTeams = useCallback(async () => {
    if (!token) return;
    try {
      const data = await api.getTeams();
      if (Array.isArray(data)) setTeams(data);
    } catch (e) {
      showToast("Error al cargar equipos", "error");
    } finally {
      setTeamsCargados(true);
    }
  }, [token]);

  const createTeam = async (d) => {
    try {
      const newTeam = await api.createTeam({
        name:    d.name,
        color:   d.color || "#0b7d96",
        icon:    d.icon  || "people-fill",
        members: d.members || [],
      });
      setTeams(p => [...p, { ...newTeam, id: String(newTeam.id) }]);
      showToast("Equipo creado");
    } catch (e) {
      showToast(e.message || "Error al crear equipo", "error");
    }
  };

  const updateTeam = async (id, d) => {
    try {
      const updated = await api.updateTeam(id, {
        name:    d.name,
        color:   d.color,
        icon:    d.icon,
        members: d.members || [],
      });
      setTeams(p => p.map(t => String(t.id) === String(id) ? { ...t, ...updated, id: String(updated.id) } : t));
      showToast("Equipo actualizado");
    } catch (e) {
      showToast(e.message || "Error al actualizar equipo", "error");
    }
  };

  const deleteTeam = async (id) => {
    try {
      await api.deleteTeam(id);
      setTeams(p => p.filter(t => String(t.id) !== String(id)));
      showToast("Equipo eliminado", "warn");
    } catch (e) {
      showToast(e.message || "Error al eliminar equipo", "error");
    }
  };

  const addTeamMember = async (teamId, userId) => {
    const team = teams.find(t => String(t.id) === String(teamId));
    if (!team) return;
    const newMembers = [...new Set([...(team.members || []), String(userId)])];
    await updateTeam(teamId, { ...team, members: newMembers });
  };

  const removeTeamMember = async (teamId, userId) => {
    const team = teams.find(t => String(t.id) === String(teamId));
    if (!team) return;
    const newMembers = (team.members || []).filter(m => String(m) !== String(userId));
    await updateTeam(teamId, { ...team, members: newMembers });
  };

  return { teams, setTeams, teamsCargados, loadTeams, createTeam, updateTeam, deleteTeam, addTeamMember, removeTeamMember };
}
